import { Observable } from "rxjs/Observable";
import { RequestOptions, Http, Headers } from "@angular/http";
import { Injectable } from "@angular/core";
import { AuthService } from "../../shared/models/auth.service";
import { IAPIResponse, DataListModel, WeGoConfig } from "../../shared/config";
import { JQueryHelperService } from "../../shared/models/jquery-helper.service";
import { CostAndExpenseModel } from "./cost-expense.model";

@Injectable()
export class CostAndExpenseService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();

  constructor(private authService: AuthService, private http: Http) { }

  public GetCostAndExpenseList(
    model: CostAndExpenseModel,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getBookingOverviewUrl = WeGoConfig.API_GET_COSTANDEXPENSE_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringCostAndExpense = this.JQueryHelper.Param(model);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingOverviewUrl =
      getBookingOverviewUrl +
      "?" +
      queryStringDataListModel +
      "&" +
      decodeURIComponent(queryStringCostAndExpense);

    return this.http
      .get(getBookingOverviewUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportCostAndExpenseList(
    model: CostAndExpenseModel,
    input?: DataListModel
  ): any {
    input.currentPage = 0;
    let getBookingOverviewUrl = WeGoConfig.API_EXPORT_COSTANDEXPENSE_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringCostAndExpense = this.JQueryHelper.Param(model);
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    getBookingOverviewUrl =
      getBookingOverviewUrl +
      "?" +
      queryStringDataListModel +
      "&" +
      decodeURIComponent(queryStringCostAndExpense);

    return this.http.get(getBookingOverviewUrl, options);
  }

  public DeleteCostAndExpenses(
    selectedcostandExpensesHashId: string[]
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let getContractTypeUrl = WeGoConfig.API_POST_DELETE_COSTANDEXPENSE;

    return this.http
      .post(getContractTypeUrl, selectedcostandExpensesHashId, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCostAndExpenseByHashId(
    costandExpensesHashId: string
  ): Observable<IAPIResponse> {
    let getContractTypeUrl =
      WeGoConfig.API_GET_COSTANDEXPENSE_BY_HASH +
      "?costAndExpenseHashId=" +
      costandExpensesHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getContractTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownCostTypeList(
    reportedByPerosnHashId: string = "",
    addreseeDriverHashId: string = "",
    addreseeOrganizationHashId: string = ""
  ): Observable<IAPIResponse> {
    let getCostTypeUrl: string;
    getCostTypeUrl = WeGoConfig.API_GET_DROPDOWN_COSTTYPE_LIST;
    getCostTypeUrl =
      getCostTypeUrl +
      "?reportedByPerosnHashId=" +
      reportedByPerosnHashId +
      "&addreseeDriverHashId=" +
      addreseeDriverHashId +
      "&addreseeOrganizationHashId=" +
      addreseeOrganizationHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCostTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownOrganizationList(
    reportedByPerosnHashId: string,
    reportedByDriver: boolean
  ): Observable<IAPIResponse> {
    let getCostTypeUrl: string;
    getCostTypeUrl =
      WeGoConfig.API_GET_DROPDOWN_COSTANDEXPENSE_ORGANIZATION_LIST;
    getCostTypeUrl =
      getCostTypeUrl +
      "?reportedByPerosnHashId=" +
      reportedByPerosnHashId +
      "&reportedByDriver=" +
      reportedByDriver;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCostTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AcceptReject(
    model: CostAndExpenseModel,
    approve: boolean,
    reject: boolean
  ): Observable<IAPIResponse> {
    let body = model;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    let getCostTypeUrl = WeGoConfig.API_POST_APPROVE_REJECT_COSTANDEXPENSE;
    getCostTypeUrl =
      getCostTypeUrl + "?approve=" + approve + "&reject=" + reject;

    return this.http
      .post(getCostTypeUrl, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetApprovedExpenseList(
    sharedVehicleDriverHashId: string,
    organizationHashId: string
  ): Observable<IAPIResponse> {


    let getCostTypeUrl: string;
    getCostTypeUrl = WeGoConfig.API_GET_APPROVED_COSTANDEXPENSE_LIST;

    if (sharedVehicleDriverHashId) {
      getCostTypeUrl = getCostTypeUrl +
        "?sharedVehicleDriverHashId=" + sharedVehicleDriverHashId
    } else if (organizationHashId) {
      getCostTypeUrl = getCostTypeUrl +
        "?organizationHashId=" + organizationHashId;
    }


    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCostTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/cost-expenses/models/cost-expense.service.ts